define("Finis.FinisAging.aging", [
  "Finis.FinisAging.aging.View",
  "Backbone",
], function (AgingView, Backbone) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");

      if (layout) {
        const agingView = new AgingView();

        layout.addToViewContextDefinition(
          "Header.View",
          "aging",
          "object",
          function () {
            return {
              aging: agingView.aging,
              overDue: agingView.overDue,
            };
          }
        );

        layout.on("afterAppendView", function (viewInstance) {
          const viewName =
            viewInstance &&
            viewInstance.attributes &&
            viewInstance.attributes.id;

          if (viewName === "Balance.View") {
            layout.addToViewContextDefinition(
              "Balance.View",
              "aging",
              "object",
              function () {
                return {
                  aging: agingView.aging,
                  overDue: agingView.overDue,
                };
              }
            );
          }
        });

        jQuery(document).on("click", 'a[data-id="balance"]', function () {
          Backbone.trigger("refreshAgingData");
        });
      }
    },
  };
});
